module.exports = "https://cdn.dashboard.gifty.nl/5342/images/logo.svg?9c0e9558a6de74cb415462b66a20a062";